<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
            title="Orderregel toevoegen"
            :addClose="true"
            @close="close"
    >
      Weet u het zeker? Hiermee wordt de dienst {{ payloadData.service.name }} verwijderd.
      <span slot="dean-dialog-button-group">
          <dean-button :warning="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
          <dean-button :success="true" :dialog-button="true" @click.native="remove()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import axios from 'axios';
  import { Component, Prop } from 'vue-property-decorator';
  import {
    // SVG
    warningIcon,
    saveIcon,
    // COMPONENTS
    deanDialog,
  } from '@deanone/dean-components';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import { deanDialogBus } from '@/main';

  @Component({
    components: {
      warningIcon,
      saveIcon,
      deanDialog,
      deanButton,
    },
  })

  export default class QuoteRemoveServiceDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: any,
    };
    private readonly removeServiceUrl: string = '/-/trade/api/quote.service.remove';

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public remove() {
      axios.post(this.removeServiceUrl,
        {
          id: this.payloadData.id,
          service: this.payloadData.service.id,
          location: this.payloadData.location,
        },
      ).then(
        (response) => {
          (this as any).data = [];
          this.$toast({
            icon: saveIcon,
            text: 'Orderregel verwijderd',
            theme: 'success',
            title: 'Verwijderd',
          });
          deanDialogBus.$emit('QuoteRefresh');
          deanDialogBus.$emit('close');
        },
        (error) => {
          // tslint:disable-next-line:no-console
          console.error(error);
          deanDialogBus.$emit('close');
        },
      );
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';

  :deep(.dean-load-overlay) {
    width: 100%;
    height: 100%;
    position: absolute;

    :deep(.dean-overlay) {
      position: absolute;
    }
  }
</style>
